import { Visibility } from '../../types/visibility'
import { VISIBILITY_META } from '../../lib/visibilityMeta'

interface VisibilityBadgeProps {
  visibility: Visibility
  className?: string
}

export const VisibilityBadge = ({ visibility, className = '' }: VisibilityBadgeProps) => {
  const meta = VISIBILITY_META[visibility] ?? VISIBILITY_META.private
  const Icon = meta.icon
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium ${meta.badgeClass} ${className}`}>
      <Icon className="w-3 h-3" />
      {meta.label}
    </span>
  )
}